//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DiagnosticCriteriaofAnkylosingspondylitis',
  data () {
    return {
      form: {
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0'
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          form[key] = Number(form[key])
        }
      }
      if (form.data4 && (form.data1 === 1 || form.data2 === 1 || form.data3 === 1)) {
        return '强制性脊柱炎'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/DiagnosticCriteriaofAnkylosingspondylitis.vue